import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import LoginPrompt from 'components/sharedComponents/LoginPrompt'
import ProfilePage from 'components/pagesContent/MyBlocket'
import staticFilesUrl from 'constants/staticFiles'

const Img = styled.img`
  max-width: 238px;
`

const Illustration = () => (
  <Img
    aria-hidden
    alt="illustration inloggning"
    src={`${staticFilesUrl}/assets/images/profile-login.png`}
    srcSet={
      `${staticFilesUrl}/assets/images/profile-login@2x.png 2x, ` +
      `${staticFilesUrl}/assets/images/profile-login@3x.png 3x`
    }
  />
)

const ProfileIndex = () => {
  const loggedIn = useSelector((state) => state.account.user.loggedIn)

  if (!loggedIn) {
    return (
      <LoginPrompt
        redirectUri="/mitt-blocket"
        cancelUri="/mitt-blocket"
        icon={<Illustration />}
        headline="Din plats på Blocket"
        infoText="Hantera din profil och annonser du publicerat. Du ser även annonser från dina bevakningar och sparade annonser."
        tag="profile"
      />
    )
  }
  return <ProfilePage />
}

export default ProfileIndex
